import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import {
  Receipt,
  ReceiptDetail,
  ReceiptInventory,
} from "../../models/receipt.model";
import { StbCustomRenderDateComponent } from "../smart-table-customs/custom-render-date";
import { StbCustomRenderIdComponent } from "../smart-table-customs/custom-render-id";
import * as moment from "moment";
import { Employee } from "../../models/employee.model";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { DialogReceiptDeliveryComponent } from "../dialog-receipt-delivery/dialog-receipt-delivery.component";
import { NbDialogService } from "@nebular/theme";
import Shop from "../../models/shop.model";
import { ReceiptInventoryService } from "../../services/receipt-inventory.service";
import { DialogViewReceiptComponent } from "../dialog-view-receipt/dialog-view-receipt.component";

@Component({
  selector: "ngx-view-table-receipt-inventories",
  styleUrls: ["./view-table-receipt-inventories.component.scss"],
  templateUrl: "./view-table-receipt-inventories.component.html",
})
export class ViewTableReceiptInventoryComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() employeesDeliverer: Employee[] = [];
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";
  user: User;
  periodType = "day";
  periodDate: Date = moment().toDate();
  fromDate: Date = moment().startOf("day").toDate();
  toDate: Date = moment().endOf("day").toDate();

  employeeDeliveryId: string = "";
  employeeDeliveryName: string = "";
  isDelivered: string = "";

  receiptSubs: any;
  receipts?: Receipt[] = [];
  receiptDeliverySubs: any;
  receiptDeliveries?: Receipt[] = [];
  receiptDetails?: ReceiptDetail[] = [];
  totalQuantity: number = 0;

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  // settings: any;
  settings = {
    hideHeader: false,
    noDataMessage: "",
    attr: {
      class: "table table-striped",
    },
    actions: {
      columnTitle: "",
      add: false,
      edit: false,
      delete: false,
    },
    columns: {},
  };

  constructor(
    private userService: UserService,
    private receiptService: ReceiptInventoryService,
    private dialogService: NbDialogService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              issueDate: {
                title: user.language == "en" ? "Date" : "Ngày HĐ",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              // id: {
              //   title: user.language == "en" ? "Code" : "Số phiếu",
              //   type: "custom",
              //   renderComponent: StbCustomRenderIdComponent,
              // },
              customerName: {
                title: user.language == "en" ? "Customer" : "Khách hàng",
                type: "string",
              },
              customerMobile: {
                title: user.language == "en" ? "Mobile" : "Di động",
                type: "string",
              },
              totalAmount: {
                title: user.language == "en" ? "Amount" : "Tổng tiền",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              note: {
                title: user.language == "en" ? "Note" : "Ghi chú",
                type: "string",
              },
              status: {
                title: user.language == "en" ? "Status" : "Trạng thái",
                type: "string",
              },
            },
          };

          this.getReceipts();
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectTime(value) {
    if (value) {
      this.periodDate = value.periodDate;
      this.fromDate = value.fromDate;
      this.toDate = value.toDate;
      this.periodType = value.type;

      console.log(
        `selectTime ${this.periodType}/ fromDate: ${this.fromDate}/ toDate: ${this.toDate}`,
      );

      this.getReceipts();
    }
  }

  onNew() {
    this.router.navigateByUrl(`/inventory/${this.uid}`);
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);
    this.viewDetailInventory(item);
  }

  private getReceipts() {
    this.loading = true;
    if (this.receiptSubs) this.receiptSubs.unsubscribe();

    this.receiptSubs = this.receiptService
      .getReceiptInventories(this.shopId, this.fromDate, this.toDate)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          })),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (data) => {
          this.receipts = data;
          this.summaryReceipt();
          console.log("getReceipts:", this.receipts);

          this.loading = false;
        },
        (err) => {
          this.receipts = [];
          this.summaryReceipt();
          this.loading = false;
          console.log("getReceipts/err:", err);
        },
      );
  }

  summaryReceipt() {
    this.receiptDeliveries = [];
    this.receiptDetails = [];
    this.totalQuantity = 0;

    _.forEach(this.receipts, (item) => {
      _.forEach(item.receiptDetails, (itemD) => {
        let expDetail: ReceiptDetail = new ReceiptDetail();
        expDetail = itemD;

        this.totalQuantity += itemD.quantity;
        this.receiptDetails.push(expDetail);
      });
    });

    this.source.load(this.receipts);
  }

  viewDetailInventory(item: ReceiptInventory) {
    // this.dialogService
    //   .open(DialogViewReceiptInventoryComponent, {
    //     context: {
    //       shopId: this.shopId,
    //       receipt: item,
    //       shop: this.shop,
    //       user: this.user,
    //     },
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //     }
    //   });
  }
}
